import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css';
import { BrowserRouter } from "react-router-dom";
import IndexRoutes from './routes/IndexRoutes';

//hooks
import { useSelectedProduct } from './hooks/main/useSelectedProduct';
import { useIsComparing } from './hooks/main/useIsComparing';

const routerBasename = window._env_.REACT_APP_ROUTER_BASENAME || '/';

const App = () => {
  const { selectedProduct } = useSelectedProduct();
  const { isComparing } = useIsComparing();

  useEffect(() => {
    global.scrollTo(0, 0);
  }, [selectedProduct, isComparing]);

  return (
    <div data-testid="app-Test" className='searcher-funds-react23'>
        <BrowserRouter basename={routerBasename}>
          <IndexRoutes/>
        </BrowserRouter>
    </div>
  );
};

export default App;
